export function findGetParameter(parameterName) {
  let result = null,
    tmp = [];
  location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

export function getQueryParams() {
  const urlParams = new URL(window.location?.href)?.searchParams;
  return [...urlParams?.entries()]?.reduce?.((acc, [key, value]) => ({ ...acc, [key]: value }), {});
}
